<!-- 旗子点击弹窗 -->
<template>
  <div v-if="!$isEmpty(content)" class="flag-alert-modal">
    <div class="flag-alert-container">
      <div class="content">
        <div v-if="!$isEmpty(title)" class="title">{{title}}</div>
        <div v-if="!$isEmpty(content)" class="content-text">{{content}}</div>
      </div>
      <div class="btn-group">
        <div :style="{ color: btnConfig.leftTextColor || '#000000'}"
          @click="() => { this.$emit('clickLeft'); }"
          class="btn-item"
          >{{btnConfig.leftText}}</div>
        <div v-if="!$isEmpty(btnConfig.rightText)"
          :style="{
            color: btnConfig.rightTextColor || '#000000',
            borderLeft: '1px solid #eeeeee'
          }"
          @click="() => { this.$emit('clickRight')}"
          class="btn-item"
        >{{btnConfig.rightText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'flag-alert-modal',

  props: {
    content: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    btnConfig: {
      type: Object,
      default: () => ({
        leftText: '知道了',
        leftTextColor: '#000000',
      }),
    },
  },
};
</script>

<style lang="less" scoped>
.flag-alert-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  .flag-alert-container {
    width: 560px;
    background-color: #ffffff;
    border-radius: 24px;
    .content {
      text-align: center;
      .title {
        font-size: 36px;
        color: #000000;
      }
      .content-text {
        font-size: 32px;
        color: #000000;
        margin-top: 24px;
        line-height: 45px;
        p {
          margin: 0;
        }
      }
      padding: 48px 56px;
      border-bottom: 2px solid #eeeeee;
    }
    .btn-group {
      display: flex;
      flex-direction: row;
      .btn-item {
        text-align: center;
        flex:1;
        box-sizing: border-box;
        font-size: 32px;
        line-height: 112px;
      }
    }
  }
}
</style>
